<template>
	<div>
		<div class="content-header">
            <div class="content-header-left mb-2">
                <div class="breadcrumbs-top">
                    <h2 class="content-header-title mb-0">{{ title }}</h2>
                    <div class="breadcrumb-wrapper">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="role_id == 2 ? '/' : '/kontrak'">
                                    <i class="feather icon-home"></i>
                                </router-link>
                            </li>

                            <li class="breadcrumb-item" :class="data.active == true ? 'active' : ''" style="text-transform: capitalize" v-for="(data, index) in breadcumb" :key="index">
                                <router-link :to="data.link">{{ data.name }}</router-link>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section id="basic-datatable">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <ValidationObserver v-slot="{ invalid }" class="card-content">
                                <div class="card-content">
                                    <div class="card-body card-dashboard">
                                        <h3 class="font-bold text-primary mb-2">Edit Embed</h3>
                                        
                                            <div class="col-12">
                                                <ValidationProvider name="Nama" v-slot="{ errors }" rules="required">
                                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                        <label for="">Nama</label>
                                                        <input type="text" v-model="model.name" id="" class="form-control">
                                                    </div>
                                                </ValidationProvider>
                                            </div>

                                            <div class="col-12">
                                                <ValidationProvider name="Kode HTML" v-slot="{ errors }" rules="required">
                                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                        <label for="">Kode HTML</label>
                                                        <textarea cols="30" rows="10" v-model="model.code" class="form-control" placeholder="Masukkan kode HTML"></textarea>
                                                    </div>
                                                </ValidationProvider>
                                            </div>

                                            <div class="col-12">
                                                <ValidationProvider name="Kode javascript" v-slot="{ errors }">
                                                    <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                        <label for="">Kode Javascript</label>
                                                        <textarea cols="30" rows="10" v-model="model.script" class="form-control" placeholder="Masukkan kode javascript"></textarea>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        
                                        <p>Visual Embed</p>
                                        
                                        <div class="table-responsive">
                                            <div v-html="model.code"></div>
                                        </div>
                                        <img v-if="model.code != '' && model.script != ''" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" :onload="model.script">

                                        <div class="d-flex flex-wrap justify-content-end align-items-center">
                                            <router-link to="/embed" class="btn btn-outline-primary mr-1 btn-lg" data-dismiss="modal">Batal</router-link>
                                            <button :disabled="invalid" @click="save()" type="button" class="btn btn-primary btn-lg"
                                                data-dismiss="modal">Simpan</button>
                                        </div>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </section>
        </div>
	</div>
</template>

<script>
export default {
    data() {
        return {
            title: "Embed",
            breadcumb: [
                {
                    name: 'Master Data', 
                    link: '',
                    active: false
                },
                {
                    name: 'Embed',
                    link: '/embed',
                    active: false
                },   
                {
                    name: 'Edit Embed', 
                    link: '',
                    active: true
                }            
            ],
            model: {
                name: '',
                code: '',
                script: ''
            },
            role_id: localStorage.getItem('role_id')
        }
    },
    methods: {
        get() {
            let _ = this
            _.axios.get('/embed/' + _.$route.params.id)
                .then(resp=>{
                    _.model = resp.data.data
                })
                .catch(err=>{
                    console.log(err.response)
                })
        },
        save() {
            let _ = this
            _.axios.patch('/embed/' + _.$route.params.id, _.model)
                .then(resp => {
                    if (resp.status) {
                        _.$router.push('/embed')
                        _.$toast.success('Data Berhasil Diubah')
                    }else{
                        console.log("Failed")
                        _.$toast.warning('Data Gagal Diubah')
                    }
                })
                .catch(err=>{
                    console.log(err.response)
                    _.$toast.warning('Data Embed Sudah Digunakan')
                })
        }
    },
    mounted() {
        let _ = this
        _.get()        
    },
}
</script>